import { createAction } from "@reduxjs/toolkit"
import TYPES from "../types"

export const setRDXModule = createAction(TYPES.SET_REDUX_MODULE)

export const setCurrentMenuItem = createAction(TYPES.SET_CURRENT_MENUITEM)
